module.exports = __webpack_public_path__ + "static/media/FlorianGraf_sliderLeft.aaf5c12d.svg";